<app-scanner></app-scanner>

<div class="transport-details-header">
  <app-info-bar [transport]="transport"></app-info-bar>
  <app-message-bar></app-message-bar>

</div>
<div class="transport-details-content">
  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="transport-details-address">
        <mat-icon>location_on</mat-icon>
        <div class="clickable-address" (click)="openAddress()">
          <div>
            <!-- Do not put a linebreak inside the span, as it will show up in the view -->
            <span class="no-select">{{ transport.address.street || '-' }} {{ transport.address.streetNumber || '' }}</span>
          </div>
          <div>
            <!-- Do not put a linebreak inside the span, as it will show up in the view -->
            <span class="no-select">{{ transport.address.zipCode || '-' }} {{ transport.address.city || '-' }}</span>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="item-status-line">
        <span class="line-header">{{ 'transportDetails.pickup' | translate }}</span>
        <div class="item-status" [class.complete]="transport.pickupItemStatus.isComplete">
          <strong>{{ transport.pickupItemStatus.scanned }} / {{ transport.pickupItemStatus.total }}</strong>
          <mat-icon class="checkmark">check_circle_outline</mat-icon>
        </div>
      </div>
      <div *ngFor="let category of transport.pickupItemStatus.categories" class="item-category-line"
           [class.complete]="category.isComplete">
        <mat-icon class="category-icon" [svgIcon]="category.iconName"></mat-icon>
        <span>{{ category.name }}</span>

        <span style="flex-grow: 1"></span>
        <span>{{ category.scannedCount }}/{{ category.totalCount }}</span>
        <mat-icon class="checkmark">check_circle_outline</mat-icon>
      </div>
      <div class="item-status-line">
        <span class="line-header">{{ 'transportDetails.handover' | translate }}</span>
        <div class="item-status" [class.complete]="transport.handoverItemStatus.isComplete">
          <strong>{{ transport.handoverItemStatus.scanned }} / {{ transport.handoverItemStatus.total }}</strong>
          <mat-icon class="checkmark">check_circle_outline</mat-icon>
        </div>
      </div>
      <div *ngFor="let category of transport.handoverItemStatus.categories" class="item-category-line"
           [class.complete]="category.isComplete">
        <mat-icon class="category-icon" [svgIcon]="category.iconName"></mat-icon>
        <span>{{ category.name }}</span>

        <span style="flex-grow: 1"></span>
        <span>{{ category.scannedCount }}/{{ category.totalCount }}</span>
        <mat-icon class="checkmark">check_circle_outline</mat-icon>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<div class="transport-details-footer">
  <button mat-icon-button (click)="openTransportPlan()" [disabled]="toolbar.navigationBlocked$ | async">
    <mat-icon fontSet="material-icons-outlined">find_in_page</mat-icon>
  </button>
  <button class="footer-button" mat-flat-button [disabled]="didScanStartCode"
          (click)="back()">{{ 'back' | translate }}</button>
  <button class="footer-button" mat-flat-button color="primary" [disabled]="!didScanStartCode"
          (click)="done()">{{ 'done' | translate }}</button>
</div>

